import "@arco-design/web-react/es/Drawer/style";
import _Drawer from "@arco-design/web-react/es/Drawer";
import _IconMenu from "@arco-design/web-react/icon/react-icon/IconMenu";
import _IconPoweroff from "@arco-design/web-react/icon/react-icon/IconPoweroff";
import "@arco-design/web-react/es/Divider/style";
import _Divider from "@arco-design/web-react/es/Divider";
import _IconDashboard from "@arco-design/web-react/icon/react-icon/IconDashboard";
import _IconExperiment from "@arco-design/web-react/icon/react-icon/IconExperiment";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import _IconTag from "@arco-design/web-react/icon/react-icon/IconTag";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconSettings from "@arco-design/web-react/icon/react-icon/IconSettings";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import React, { useContext, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { GlobalContext } from '@/context';
import useLocale from '@/utils/useLocale';
import Logo from '@/assets/photos/logo.jpg';
import Settings from '../Settings';
import styles from './style/index.module.less';
import useStorage from '@/utils/useStorage';
import { generatePermission } from '@/routes';
import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import mainStyles from "@/style/layout.module.less";
import cs from "classnames";
import IconInstagram from '@/assets/icons/instagram.svg';
import IconFacebook from '@/assets/icons/facebook.svg';
import IconLinkedin from '@/assets/icons/linkedin.svg';

function Navbar({
  show
}) {
  const location = useLocation();
  const pathname = location.pathname;
  const t = useLocale();
  const userInfo = useSelector(state => state.userInfo);
  const dispatch = useDispatch();
  const [_, setUserStatus] = useStorage('userStatus');
  const [role, setRole] = useStorage('userRole', 'admin');
  const {
    setLang,
    lang,
    theme,
    setTheme
  } = useContext(GlobalContext);
  const [drawerVisible, setDrawerVisible] = React.useState(false);

  function logout() {
    setUserStatus('logout');
    window.location.href = '/login';
  }

  function onMenuItemClick(key) {
    if (key === 'logout') {
      logout();
    } else {
      _Message.info(`You clicked ${key}`);
    }
  }

  useEffect(() => {
    dispatch({
      type: 'update-userInfo',
      payload: {
        userInfo: { ...userInfo,
          permissions: generatePermission(role)
        }
      }
    });
  }, [role]);

  if (!show) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['fixed-settings']
    }, /*#__PURE__*/React.createElement(Settings, {
      trigger: /*#__PURE__*/React.createElement(_Button, {
        icon: /*#__PURE__*/React.createElement(_IconSettings, null),
        type: "primary",
        size: "large"
      })
    }));
  }

  const handleChangeRole = () => {
    const newRole = role === 'admin' ? 'user' : 'admin';
    setRole(newRole);
  };

  const droplist = /*#__PURE__*/React.createElement(_Menu, {
    onClickMenuItem: onMenuItemClick
  }, /*#__PURE__*/React.createElement(_Menu.SubMenu, {
    key: "role",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_IconUser, {
      className: styles['dropdown-icon']
    }), /*#__PURE__*/React.createElement("span", {
      className: styles['user-role']
    }, role === 'admin' ? t['menu.user.role.admin'] : t['menu.user.role.user']))
  }, /*#__PURE__*/React.createElement(_Menu.Item, {
    onClick: handleChangeRole,
    key: "switch role"
  }, /*#__PURE__*/React.createElement(_IconTag, {
    className: styles['dropdown-icon']
  }), t['menu.user.switchRoles'])), /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "setting"
  }, /*#__PURE__*/React.createElement(_IconSettings, {
    className: styles['dropdown-icon']
  }), t['menu.user.setting']), /*#__PURE__*/React.createElement(_Menu.SubMenu, {
    key: "more",
    title: /*#__PURE__*/React.createElement("div", {
      style: {
        width: 80
      }
    }, /*#__PURE__*/React.createElement(_IconExperiment, {
      className: styles['dropdown-icon']
    }), t['message.seeMore'])
  }, /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "workplace"
  }, /*#__PURE__*/React.createElement(_IconDashboard, {
    className: styles['dropdown-icon']
  }), t['menu.dashboard.workplace'])), /*#__PURE__*/React.createElement(_Divider, {
    style: {
      margin: '4px 0'
    }
  }), /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "logout"
  }, /*#__PURE__*/React.createElement(_IconPoweroff, {
    className: styles['dropdown-icon']
  }), t['navbar.logout']));
  return /*#__PURE__*/React.createElement("div", {
    className: styles.navbar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/",
    style: {
      height: '50px'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: Logo,
    alt: "ClearMD",
    style: {
      height: '50px'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: cs(styles.navLinks, mainStyles['hide-on-mobile'])
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/sexually-transmitted-infections-testing",
    className: styles.navLink + (pathname === '/sexually-transmitted-infections-testing' ? ' ' + styles.active : '')
  }, "STI\xA0Testing"), /*#__PURE__*/React.createElement(Link, {
    to: "/schedule-covid",
    className: styles.navLink + (pathname === '/schedule-covid' ? ' ' + styles.active : '')
  }, "Covid\xA0Testing"), /*#__PURE__*/React.createElement(Link, {
    to: "/business-inquires",
    className: styles.navLink + (pathname === '/business-inquires' ? ' ' + styles.active : '')
  }, "Group\xA0Testing"), /*#__PURE__*/React.createElement(Link, {
    to: "/antigen",
    className: styles.navLink + (pathname === '/antigen' ? ' ' + styles.active : '')
  }, "At\u2011Home\xA0Testing"), /*#__PURE__*/React.createElement(Link, {
    to: "/faqs",
    className: styles.navLink + (pathname === '/faqs' ? ' ' + styles.active : '')
  }, "FAQ"))), /*#__PURE__*/React.createElement("ul", {
    className: cs(styles.right, 'noprint', mainStyles['hide-on-mobile'])
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://instagram.com/clearmdhealth",
    target: "_blank",
    className: styles['social-icon']
  }, /*#__PURE__*/React.createElement(IconInstagram, null)), /*#__PURE__*/React.createElement("a", {
    href: "https://www.facebook.com/Clear-MD-Health-105367534862633",
    target: "_blank",
    className: styles['social-icon']
  }, /*#__PURE__*/React.createElement(IconFacebook, null)), /*#__PURE__*/React.createElement("a", {
    href: "https://www.linkedin.com/company/clearmd-health/",
    target: "_blank",
    className: styles['social-icon']
  }, /*#__PURE__*/React.createElement(IconLinkedin, null))), /*#__PURE__*/React.createElement("div", {
    className: cs(styles.right, 'noprint', mainStyles['hide-on-desktop'])
  }, /*#__PURE__*/React.createElement(_Button, {
    onClick: () => {
      setDrawerVisible(true);
    },
    type: "secondary",
    style: {
      backgroundColor: '#fff',
      color: '#000',
      border: 'none'
    }
  }, /*#__PURE__*/React.createElement(_IconMenu, {
    fontSize: 24
  })), /*#__PURE__*/React.createElement(_Drawer, {
    className: styles['drawer'],
    width: '100%',
    visible: drawerVisible,
    title: "",
    footer: null,
    onOk: () => {
      setDrawerVisible(false);
    },
    onCancel: () => {
      setDrawerVisible(false);
    },
    headerStyle: {
      height: 80
    }
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/sexually-transmitted-infections-testing",
    className: styles.navLink + (pathname === '/sexually-transmitted-infections-testing' ? ' ' + styles.active : ''),
    onClick: () => setDrawerVisible(false)
  }, "STI\xA0Testing"), /*#__PURE__*/React.createElement(Link, {
    to: "/schedule-covid",
    className: styles.navLink + (pathname === '/schedule-covid' ? ' ' + styles.active : ''),
    onClick: () => setDrawerVisible(false)
  }, "Covid\xA0Testing"), /*#__PURE__*/React.createElement(Link, {
    to: "/business-inquires",
    className: styles.navLink + (pathname === '/business-inquires' ? ' ' + styles.active : ''),
    onClick: () => setDrawerVisible(false)
  }, "Group\xA0Testing"), /*#__PURE__*/React.createElement(Link, {
    to: "/antigen",
    className: styles.navLink + (pathname === '/antigen' ? ' ' + styles.active : ''),
    onClick: () => setDrawerVisible(false)
  }, "At\u2011Home\xA0Testing"), /*#__PURE__*/React.createElement(Link, {
    to: "/faqs",
    className: styles.navLink + (pathname === '/faqs' ? ' ' + styles.active : ''),
    onClick: () => setDrawerVisible(false)
  }, "FAQ"), /*#__PURE__*/React.createElement("div", {
    className: styles['social-icons']
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://instagram.com/clearmdhealth",
    target: "_blank",
    className: styles['social-icon']
  }, /*#__PURE__*/React.createElement(IconInstagram, null)), /*#__PURE__*/React.createElement("a", {
    href: "https://www.facebook.com/Clear-MD-Health-105367534862633",
    target: "_blank",
    className: styles['social-icon']
  }, /*#__PURE__*/React.createElement(IconFacebook, null)), /*#__PURE__*/React.createElement("a", {
    href: "https://www.linkedin.com/company/clearmd-health/",
    target: "_blank",
    className: styles['social-icon']
  }, /*#__PURE__*/React.createElement(IconLinkedin, null))))));
}

export default Navbar;